<div class="generic-radio-option-dialog">
  <!-- TODO: replace with app-popup-top-line when every component is standalone -->
  <hr class="popup-top-line" />
  <div class="generic-radio-option-dialog-header">
    <div class="title">{{ data.headerTitle }}</div>
    <img src="assets/images/common/cancel.svg" class="close-icon" (click)="onClose()" />
  </div>
  <div class="generic-radio-option-dialog-body">
    @if (data.bodyTitle) {
      <div class="title">{{ data.bodyTitle }}</div>
    }
    <mat-radio-group [formControl]="selectedOptionControl">
      @for (option of data.options; track option.id; let isLast = $last) {
        <mat-radio-button [value]="option.id">
          {{ option.title }}
        </mat-radio-button>
        @if (option.description) {
          <div class="space">
            {{ option.description }}
          </div>
        }
        @if (!isLast) {
          <br />
        }
      }
    </mat-radio-group>
  </div>
  <div class="generic-radio-option-dialog-footer">
    <button
      class="button"
      cdkFocusInitial
      (click)="applyClicked()"
      [ngClass]="{
        'button-disabled': !selectedOptionControl.value || selectedOptionControl.value === '' || waitingForResponse(),
      }"
    >
      @if (!waitingForResponse()) {
        <span>{{ data.applyButtonText }}</span>
      }
      @if (waitingForResponse()) {
        <mat-progress-spinner class="spinner" color="primary" mode="indeterminate"> </mat-progress-spinner>
      }
    </button>
    @for (disclaimer of data.disclaimers; track $index) {
      <div class="disclaimer">
        {{ disclaimer }}
      </div>
    }
  </div>
</div>
